export default __webpack_public_path__ + "5fc44eb0baef6525df272a4cd59944dd.svg";